import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ProtectedRoute from "../components/ProtectedRoute";
import CandidateDashboard from "./CandidateDashboard";
import EmployerDashboard from "./EmployerDashboard";

function DashboardInner() {
  const { user } = useAuth();
  if (user?.role === "admin") return <Navigate to="/control-tower" replace />;
  if (user?.role === "employer") return <EmployerDashboard />;
  return <CandidateDashboard />;
}

export default function Dashboard() {
  return (
    <ProtectedRoute>
      <DashboardInner />
    </ProtectedRoute>
  );
}
